type RoomFetch = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;

/** Share the guest cookie bootstrap across overlapping mounts of the same room. */
export function createRoomCheck(fetchRoom: RoomFetch): (code: string) => Promise<Response> {
  const pendingByCode = new Map<string, Promise<Response>>();
  return (code) => {
    const pending = pendingByCode.get(code);
    if (pending) return pending;

    // Install the pending entry before starting the request, including a synchronous throw.
    const request = Promise.resolve()
      .then(() => fetchRoom(`/api/rooms/${encodeURIComponent(code)}`, { credentials: 'include' }))
      .finally(() => {
        if (pendingByCode.get(code) === request) pendingByCode.delete(code);
      });
    pendingByCode.set(code, request);
    return request;
  };
}
